export function ozToUserUnit(oz: number, unit: 'oz' | 'g'): number {
  return unit === 'g' ? Number((oz * 28.3495).toFixed(2)) : oz
}

export function userUnitToOz(value: number, unit: 'oz' | 'g'): number {
  return unit === 'g' ? Number((value / 28.3495).toFixed(2)) : value
}

export function userUnitToInches(value: number, unit: 'in' | 'cm'): number {
  return unit === 'cm' ? Number((value / 2.54).toFixed(2)) : value
}

export function inchesToUserUnit(inches: number, unit: 'in' | 'cm'): number {
  return unit === 'cm' ? Number((inches * 2.54).toFixed(2)) : inches
}
